import { useSelector } from 'react-redux'
import { loadedBotApiUrlSelector } from '../selectors'

export function useLoadedBotApiUrl() {
  return useSelector(loadedBotApiUrlSelector)
}
